<template>
  <div class="leadership-container" style="background-color: #ffffff;">
    <img class="top-bg bannerImgcss0"  src="../../assets/img3/msgpublic/lingdaoxinxi-bg.png" alt="领导信息背景图">

    <!-- 优化后的导航容器 -->
    <div class="menu001" v-scroll-animate="'slide-itemgk'">   
        <div class="procard_btn" v-if="cengji ==0">
            <div class="procard_item"
              v-for="(item, index) in columnList"
              :key="index"
              :class="typeObj === index ? 'active' : ''"
              @click="changeTypeobj(index,item)"
            >
              {{ item.name }}
            </div>
            <!-- 移动端菜单 -->
            <el-row class="mobileGkmenu">
              <el-col :xs="12" v-for="(item, index) in columnList" :key="index">
                <div  :class="typeObj === index ? 'mobileGkdiv active' : 'mobileGkdiv'" @click="changeTypeobj(index,item)">{{ item.name }}</div> 
              </el-col>
            </el-row>
        </div>
      </div>
 

    <div class="content-wrapper">
      <LeaderInfo
      
        v-if="typeObj === 0"
        :leaders="leadersData"
        class="leader-info-container"
      />
      
      <AffairsPublic 
      @changeCengji="changeCengji"
      @changeCengji0="changeCengji0"
      v-else-if="typeObj === 1"
        :articles="articlesData"
        :current-page="currentPage"
        :total-pages="totalPages"
        :total-num="totalNum"
        :page-size="pageSize"
        @page-change="handlePageChange"
      />

      <!-- <AffairsPublic1 
      @changeCengji="changeCengji"
      @changeCengji0="changeCengji0"
      v-else-if="typeObj === 2"
        :articles="articlesData1"
        :current-page="currentPage"
        :total-pages="totalPages1"
        :total-num="totalNum1"
        :page-size="pageSize"
        @page-change="handlePageChange"
      /> -->
      <CgList :cardId="cardId" v-else-if="typeObj === 2" />
    </div>
  </div>
</template>

<script>
import LeaderInfo from '@/components/infogw/LeaderInfo.vue'
import AffairsPublic from '@/components/infogw/AffairsPublic.vue'
// import AffairsPublic1 from '@/components/infogw/AffairsPublic1.vue'
import CgList from '@/components/CgList/index.vue'
import API from '@/api/bsInfo'
import API1 from '@/api/index'


export default {
  components: {
    LeaderInfo,
    AffairsPublic,
    // AffairsPublic1
    CgList
  },
  data() {
    return {
      cardId:null,
      columnList: [
        {name: '领导信息'},
        {name: '企务公开'}
      ],
      cengji:0,
      currentPage: 1,
      pageSize: 7,
      leadersData: [],
      articlesData: [],
      articlesData1:[],
      totalNum: 0,
      totalPages: 1,
      totalNum1: 0,
      totalPages1: 1,
      isLoading: false,
      typeObj: 0,
      currentObj:{},
    }
  },
  mounted() {
    this.getList()
  },
  created() {
    const queryParams = this.$route.query;
    [this.$route.query.activeTab, this.$route.query.typeObj].forEach(param => {
      const numParam = Number(param)
      if (!isNaN(numParam) && [0, 1].includes(numParam)) {
        this.typeObj = numParam
      }
    })
  },
  methods: {
    changeCengji(){
      this.cengji=1
    },
    changeCengji0(){
      
      this.cengji=0
    },
    async getList(obj) {
      try {
        this.isLoading = true
        const res = await API.getCategoryById({
            catId: "07272dbd062c4525b79109e2e4b11808",
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            flag: 1
          })

        this.leadersData = res?.data?.titleList?.[0]?.informationList || []
        
        this.columnList=res.data.titleList
        // this.processArticles(res)
       

      } catch (error) {
        console.error('数据获取失败:', error)
      } finally {
        this.isLoading = false
      }
    },
    processArticles(res) {
      // 企务公开
      const rawArticles = res?.data?.titleList?.[0]?.articleList || []
     
      this.totalNum = res.data.titleList[0].mapPage.totalNum || 0
      this.totalPages = res.data.titleList[0].mapPage.totalPage || 1

      this.articlesData = rawArticles.map(article => ({
        id: article.id,
        title: article.title || '未命名文章',
        createDate: article.publishDate?.split(' ')[0] || '日期未知',
        content: this.truncateContent(article.articleData?.content)
      }))

      this.articlesData.forEach(item=>{
        item['content1']=this.getPlainText(item.content)
      })

      this.cardId=
     this.getZhaocaimsg()
    },
    getZhaocaimsg(){
       // 招采信息
      // const rawArticles1 = res?.data?.titleList?.[2]?.articleList || []
      // this.totalNum1 = res.data.titleList[2].mapPage.totalNum || 0
      // this.totalPages1 = res.data.titleList[2].mapPage.totalPage || 1
      // this.articlesData1 = rawArticles1.map(article => ({
      //   id: article.id,
      //   title: article.title || '未命名文章',
      //   createDate: article.publishDate?.split(' ')[0] || '日期未知',
      //   content: this.truncateContent(article.articleData?.content)
      // }))

      // this.articlesData1.forEach(item=>{
      //   item['content1']=this.getPlainText(item.content)
      // })
    },
    getPlainText(htmlString) {
      const tempDiv = document.createElement('div')
      tempDiv.innerHTML = htmlString
      return tempDiv.textContent || tempDiv.innerText || ''
    },
    truncateContent(html) {
      const cleanText = html?.replace(/<[^>]+>/g, '')?.replace(/\s+/g, ' ')?.trim() || ''
      return cleanText.length > 60 ? `${cleanText.substring(0, 60)}...` : cleanText || '暂无内容'
    },
    handlePageChange(page) {
      if (page !== this.currentPage) {
        this.currentPage = page
       
      
        
        this.getlistOther(this.currentObj)
       
      
      }
    },
    changeTypeobj(index,item) {
      if (this.typeObj !== index) {
        this.typeObj = index
        // if (index === 1) this.getList('1')
        // else if (index === 2) this.getList('2')
      }
      this.currentObj=item
      if(index != '0'){
        
        this.getlistOther(item)
      }

     
    },

     // 1级页面其他tab框获取数据方法 获取数据方法
     getlistOther(item){
               if(this.typeObj == 1){
                  this.articlesData=[]
                  this.getlistOtherMsg(item)
                }else if(this.typeObj == 2){
                  this.cardId=item.id
                  this.articlesData1=[]
                }
     },
     async getlistOtherMsg(item) {
       try {
         const params = {
           catId: item.id,
           pageNum: this.currentPage,
           pageSize: this.pageSize // 确保传参
         };
         
        //  catId=7a8fd56b174b45d5860d301b9a0ecad3&pageNum=1&pageSize=8&flag=1
         const res = await API1.getArticleDataLists(params);
         
           this.$nextTick(()=>{
                let rawArticles=[]
               if(res.data.artList.length>7){
                  rawArticles=res.data.artList.slice(0,7)

               }else{
                  rawArticles=res.data.artList
               }


               this.totalNum = res.data.totalNum || 0
                this.totalPages = res.data.totalPage || 1

                let articlesData = rawArticles.map(article => ({
                  id: article.id,
                  title: article.title || '未命名文章',
                  createDate: article.publishDate?.split(' ')[0] || '日期未知',
                  content: this.truncateContent(article.content)
                }))

                if(this.typeObj == 1){
                  this.articlesData=articlesData
                } 
              
                  
           })
       } catch (error) {
         console.error('数据加载失败', error);
         this.$message.error('数据加载失败');
       }
     },
  }
}
</script>


<style lang="scss" scoped>

.menu001{
  width: 90vw;
  margin: 0 auto;
}
.leadership-container {
  min-height: 100vh;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  position: relative;
  
  .procard_btn {
  width: 100%;
  display: flex;
  margin-top:-1rem;
  .mobileGkmenu{
    display:none;
  }
  .procard_item {
    flex: 1;
    height: 60px;
    background: rgba(255,255,255,1);
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:1.1rem;
    position: relative;
    cursor: pointer;
    color: #015293;
    transition: all 0.3s ease;
    @media screen and (max-width: 768px) {
      display:none;
      height: 60px;
      text-align: center;
      font-size: 12px;
      color: #015293;
      transition: all 0.3s ease;
    }
  }
  .active {
    color: #fff;
    transform: translateY(-3px);
    background: #015293;
    // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
    box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
    font-weight: bold;
    &::before {
      // content: '▲';
      position: absolute;
      color: #015293;
      font-size: 40px;
      transform: rotateX(180deg);
      bottom: -27px;
    }
  }
  @media screen and (max-width: 768px) {
    
    .mobileGkmenu{
        display:block;
        width:100%;
        // height:10rem;
        .mobileGkdiv{
          background: rgba(255,255,255,1);
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
          margin:0.25rem;
          line-height:2rem;
          text-align:center;
          font-size:1rem;
        }
        .active {
          color: #fff;
          // background: linear-gradient(135deg, #0649b8, #03d2c5);
          // background: linear-gradient(to right, rgb(220, 241, 248),#058ad6);
          background: #015293 !important;
          box-shadow: 0 4px 15px rgba(3, 210, 197, 0.3);
          font-weight: bold;
          &::before {
            content: '';
          }
        }
      }
  }
}
 

  .content-wrapper {
    flex: 1;  
    padding: 0;
    // padding-bottom: 50px;
    .leader-info-container {
      width: 100%;
      // margin: 2rem auto;
      box-sizing: border-box;
      // @media (max-width: 1280px) {
      //   width: 90%;
      // }
      @media (max-width: 768px) {
        width: 94%;
      }
      @media (max-width: 480px) {
        width: 100%;
      }
    }
  }
}

.bannerImgcss0 {
    // height: 12.5rem !important;
}
</style>